import React, { useEffect, useState } from "react";
import { Paper, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import { ApiServices } from "../../utils/ApiService";

export default function ProcessorDashboardPage() {
  const [metrics, setMetrics] = useState(null);

  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await ApiServices.get(`/file/processor-dashboard/${userId}`);
        if (response?.status === 200) {
          setMetrics(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch processor dashboard metrics", error);
      }
    };

    if (userId) {
      fetchMetrics();
    }
  }, [userId]);

  const tiles = metrics
    ? [
        { label: "Today Login", count: metrics.today_login, bgColor: "#1565c0" },
        { label: "Total Login", count: metrics.total_login, bgColor: "#2e7d32" },
        { label: "Today Completed", count: metrics.today_completed, bgColor: "#00897b" },
        { label: "Total Completed", count: metrics.total_completed, bgColor: "#c62828" },
        { label: "Today Query Raised", count: metrics.today_query_raised, bgColor: "#ef6c00" },
        { label: "Total Query Raised", count: metrics.total_query_raised, bgColor: "#d84315" },
        { label: "Query Not Raised", count: metrics.total_query_not_raised, bgColor: "#6a1b9a" },
      ]
    : [];

  const chunkTiles = (array, size) => {
    return array.reduce((acc, _, index) => {
      if (index % size === 0) acc.push(array.slice(index, index + size));
      return acc;
    }, []);
  };

  const rows = chunkTiles(tiles, 4);

  return (
    <Box sx={{ padding: 3 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          color: "#131d38",
          textAlign: "center"
        }}
      >
        Yaazh Legal Associates
      </Typography>

      {rows?.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
            mb: 3,
            flexWrap: "wrap"
          }}
        >
          {row?.map((tile, tileIndex) => (
            <motion.div
              key={tileIndex}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
              style={{ width: "100%", maxWidth: "200px" }}
            >
              <Paper
                elevation={4}
                sx={{
                  p: 3,
                  backgroundColor: tile.bgColor,
                  color: "#ffffff",
                  borderRadius: 3,
                  textAlign: "center",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                  height: "100%"
                }}
              >
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {tile.label}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "#ffffff" }}
                >
                  {tile.count}
                </Typography>
              </Paper>
            </motion.div>
          ))}
        </Box>
      ))}
    </Box>
  );
}
